import type { Link, LinkAction } from '../types';

/*
 * This helper is needed to unpack "LinkAction" with "Link" inside into a flat object
 *
 * We are retiring the usage of `internalTitle` coming from "Link"
 * in favor of `actionText` coming from "LinkAction", but for now
 * this helper provides support for both options
 *
 * Once migration is over, we need to remove the condition logic
 * and everything past the `if` block
 */

export function getLinkFromLinkOrLinkAction(linkOrLinkAction: Link | LinkAction) {
    // TODO: remove this `if` statement after migration is done
    if ('link' in linkOrLinkAction) {
        return {
            actionText: linkOrLinkAction.actionText,
            sysId: linkOrLinkAction.link.sysId,
            webUrl: linkOrLinkAction.link.webUrl,
            iconName: 'iconName' in linkOrLinkAction.link ? linkOrLinkAction.link.iconName : undefined,
        };
    }
    // TODO: remove everything past this line after migration is done
    const { internalTitle, ...link } = linkOrLinkAction;
    return {
        ...link,
        actionText: internalTitle,
    };
}
